"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const refreshToken = (() => {
    let timeout = null;
    const refresh = (expires) => {
        timeout = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const newExpires = yield (0, app_1.createClient)().mutate('refreshToken');
            if (newExpires) {
                refresh(newExpires.getTime());
            }
            else {
                const loginPath = (_a = process.env.NEXT_PUBLIC_LOGIN_PATH) !== null && _a !== void 0 ? _a : '/login';
                window.location.replace(loginPath);
            }
        }), expires - Date.now() - (0, utils_1.parseTime)('10m'));
    };
    return (expires) => timeout !== null && timeout !== void 0 ? timeout : refresh(expires.getTime());
})();
function useAuth() {
    const { data, loading } = (0, app_1.useQuery)('me', {
        select: { email: true, name: true, roles: true, sessionExpires: true },
    });
    const expires = data === null || data === void 0 ? void 0 : data.sessionExpires;
    const [logoutMutation] = (0, app_1.useMutation)('logout', { clearCache: true });
    (0, react_1.useEffect)(() => {
        if (expires) {
            refreshToken(expires);
        }
    }, [expires]);
    const logout = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        try {
            yield logoutMutation();
        }
        catch (error) {
            console.error(error);
        }
    }), [logoutMutation]);
    return { user: data, loading, logout };
}
exports.useAuth = useAuth;
